/**
 * ## Animation de chiffres
 * @param {Element} Element du DOm à animer 
 * 
 * **data-start** : le chiffre de départ avant l'animation 
 *  
 */
export function animateNumbers(el){
   if(el){
      
        let endNumber = parseFloat(el.parentNode.parentNode.dataset.end);
        let startNumber = parseInt(el.parentNode.parentNode.dataset.start);
        let difference = endNumber - startNumber;
        let timming = 2000; // 1000 = 1sec
        let finesseIncrement = 30;
        let increment = Math.round( ( difference * 1000 / timming ) / finesseIncrement) + 1;

        function formatNumber(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        }

        let monInterval = setInterval( function(){
        
            if( startNumber < endNumber - increment){
                startNumber += increment ;
                el.firstChild.data = formatNumber(startNumber);
            
            }
            else{
                clearInterval(monInterval);
                el.firstChild.data = formatNumber(endNumber);
            }
        }, 1000 / finesseIncrement )
   }
}